import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useLanguage } from '../contexts/LanguageContext'
import { slugify } from '../utils/utils'
import { PRODUCT_PATH } from '../config/routes'

const ProductTechnicalSheet = ({ product, isButtonShow = true }) => {
  const { t } = useTranslation()

  return (
    <div className="green-frame">
      <ul className="no-space-before">
        <li>
          <strong>Id:</strong> {product.id}
        </li>
        <li>
          <strong>Nom:</strong> {product.labelFr}
        </li>
        <li>
          <Link
            to={`${PRODUCT_PATH.replace(
              ':slug',
              slugify(product.labelFr),
            ).replace(':id', product.id)}`}
            className="btn btn-primary btn-margin-10"
          >
            {t('SHOW')}
          </Link>
        </li>
      </ul>
    </div>
  )
}

export default ProductTechnicalSheet
